import { DOWN_ARROW, ENTER, ESCAPE, hasModifierKey, TAB, UP_ARROW } from '@angular/cdk/keycodes';

/**
 * @see https://github.com/angular/components/blob/4888ffdbc67317905e23cadf520b69fd47bb37ef/src/material/autocomplete/autocomplete-trigger.ts#L408
 * @param onEnter
 */
export function genericAutocompleteInputHandleKeydown(onEnter: (event: KeyboardEvent) => void) {
    return function(event: KeyboardEvent): void {
        const keyCode: number = event.keyCode;
        const hasModifier: boolean = hasModifierKey(event);

        // Prevent the default action on all escape key presses. This is here primarily to bring IE
        // in line with other browsers. By default, pressing escape on IE will cause it to revert
        // the input value to the one that it had on focus, however it won't dispatch any events
        // which means that the model value will be out of sync with the view.
        if (keyCode === ESCAPE && !hasModifier) {
            event.preventDefault();
        }

        if (this.activeOption && keyCode === ENTER && this.panelOpen && !hasModifier) {
            onEnter(event);
            // this.activeOption._selectViaInteraction();
            // this._resetActiveItem();
            event.preventDefault();
        } else if (this.autocomplete) {
            const prevActiveItem = this.autocomplete._keyManager.activeItem;
            const isArrowKey = keyCode === UP_ARROW || keyCode === DOWN_ARROW;

            if (keyCode === TAB || (isArrowKey && !hasModifier && this.panelOpen)) {
                this.autocomplete._keyManager.onKeydown(event);
            } else if (isArrowKey && this._canOpen()) {
                this.openPanel();
            }

            if (isArrowKey || this.autocomplete._keyManager.activeItem !== prevActiveItem) {
                this._scrollToOption(this.autocomplete._keyManager.activeItemIndex || 0);

                if (this.autocomplete.autoSelectActiveOption && this.activeOption) {
                    if (!this._pendingAutoselectedOption) {
                        this._valueBeforeAutoSelection = this._element.nativeElement.value;
                    }

                    this._pendingAutoselectedOption = this.activeOption;
                    this._assignOptionValue(this.activeOption.value);
                }
            }
        }
    };
}
